import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.analysis.widget.expertise');
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';
import { Service } from "src/libs/portal/season/service";
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
    selector: 'wiz-portal-analysis-widget-expertise',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.analysis.widget.expertise/view.scss */
/* src/app/portal.analysis.widget.expertise/view.scss: no such file or directory */`],
})
export class PortalAnalysisWidgetExpertiseComponent implements OnInit, OnChanges {
    @Input() data!: ResearcherData;
    @Input() period: any;

    public researcher: any[];
    public periodStart: number;
    public periodEnd: number;
    public products: any[];

    ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            const curr = changes['period'].currentValue;
            this.periodStart = curr?.start;
            this.periodEnd = curr?.end;
            this.loadData();
        }
    }

    constructor(@Inject( Service) private service: Service) { }

    topics: string[] = [];
    chartTopics: string[] = [];
    // dataAverage: number[] = [];
    dataMine: number[] = [];

    chartRadar: Chart | null = null;

    get maxValue() {
        const rawMax = Math.max(...this.dataMine);
        const margin = Math.max(2, Math.ceil(rawMax * 0.2));
        return rawMax + margin;
    }

    public async ngOnInit() {
        await this.service.init();
        this.mapping();
        this.loadData();
        await this.service.render();

    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.periodEnd = this.data.period.end;
        this.periodStart = this.data.period.start;
        this.products = this.data.products;
        this.service.render();
    }

    private loadData() {
        if (!this.products) return;

        const filtered = this.products.filter(p => {
            const year = Number(p.pub_year);
            return year >= this.periodStart && year <= this.periodEnd;
        });

        const allKeywords: string[] = [];
        for (const p of filtered) {
            let raw = p.kr_keywords?.trim();
            if (!raw) raw = p.en_keywords?.trim();
            if (raw) {
                const parts = raw.split(";")
                    .map(x => x.trim())
                    .filter(x => x.length > 0);
                allKeywords.push(...parts);
            }
        }

        // const normalize = (kw: string) => kw.replace(/\s+/g, "");
        const freq: Record<string, number> = {};
        for (const kw of allKeywords) {
            // const norm = normalize(kw);
            freq[kw] = (freq[kw] || 0) + 1;
        }

        const sorted = Object.entries(freq).sort((a, b) => b[1] - a[1]);
        const topKeywords = sorted.slice(0, 5);

        this.chartTopics = topKeywords.map(([kw]) => kw);
        this.topics = topKeywords.map(([kw, count]) => `${kw} (${count})`);
        this.dataMine = topKeywords.map(([_, count]) => count);

        if (this.topics.length < 3) {
            this.chartRadar?.destroy();
            this.chartRadar = null; // 차트 안 그림
            return;
        }
        setTimeout(() => this.renderRadarChart(), 0);
    }


    private renderRadarChart(): void {
        if (this.chartRadar) this.chartRadar.destroy();

        // const wrappedLabels = this.chartTopics.map(label => {
        //     // 공백으로 단어 분리
        //     const parts = label.trim().split(/\s+/);

        //     if (parts.length > 1) {
        //         // 두 줄로 구성
        //         const firstLine = parts.slice(0, Math.ceil(parts.length / 2)).join(" ");
        //         const secondLine = parts.slice(Math.ceil(parts.length / 2)).join(" ");
        //         return [firstLine, secondLine];
        //     }

        //     // 공백 없는 단어가 너무 길면 5글자 기준으로 강제 줄바꿈
        //     if (label.length > 8) {
        //         return [label.slice(0, 5), label.slice(5)];
        //     }

        //     return [label];
        // });
        const wrappedLabels = this.chartTopics.map((label, idx) => {
            const count = this.dataMine?.[idx] ?? 0;

            // 1) 기존처럼 라벨 줄바꿈 처리
            let lines: string[] = [];
            const parts = label.trim().split(/\s+/);

            if (parts.length > 1) {
                const firstLine = parts.slice(0, Math.ceil(parts.length / 2)).join(" ");
                const secondLine = parts.slice(Math.ceil(parts.length / 2)).join(" ");
                lines = [firstLine, secondLine];
            } else {
                if (label.length > 8) lines = [label.slice(0, 5), label.slice(5)];
                else lines = [label];
            }

            // 2) 마지막 줄에 (개수) 추가
            lines.push(`(${count})`);

            // Chart.js 멀티라인 라벨은 string[] 반환
            return lines;
        });
        const CenterPointLabelsPlugin = {
            id: 'centerPointLabels',
            afterDraw: (chart: any) => {
                const scale = chart.scales?.r;
                if (!scale) return;

                const ctx = chart.ctx;
                const labels = chart.data.labels || [];

                const color = '#707988';
                const fontSize = 14;
                const fontFamily = 'Pretendard, Apple SD Gothic Neo, sans-serif';
                const lineHeight = 18;

                const labelOffset = 30;     // 바깥으로 살짝
                const pad = 8;             // 캔버스 가장자리 여백(조절)

                const clamp = (v: number, min: number, max: number) =>
                    Math.max(min, Math.min(max, v));

                ctx.save();
                ctx.fillStyle = color;
                ctx.font = `${fontSize}px ${fontFamily}`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';

                for (let i = 0; i < labels.length; i++) {
                    const pos = scale.getPointPosition(i, scale.drawingArea + labelOffset);

                    const raw = labels[i];
                    const lines = Array.isArray(raw) ? raw : [String(raw)];

                    // ✅ 라벨 블록 높이
                    const totalH = lines.length * lineHeight;

                    // ✅ 라벨 블록 "최대 텍스트 너비" 측정 (가장 긴 줄 기준)
                    let maxW = 0;
                    for (const line of lines) {
                        const w = ctx.measureText(String(line)).width;
                        if (w > maxW) maxW = w;
                    }

                    // ✅ 텍스트 너비 절반만큼은 안쪽으로 확보해야 안 잘림
                    const minX = pad + maxW / 2;
                    const maxX = chart.width - pad - maxW / 2;

                    const x = clamp(pos.x, minX, maxX);

                    // ✅ y도 블록 높이 고려해서 안 잘리게
                    const minY = pad + totalH / 2;
                    const maxY = chart.height - pad - totalH / 2;
                    const yCenter = clamp(pos.y, minY, maxY);

                    let y = yCenter - totalH / 2 + lineHeight / 2;
                    for (const line of lines) {
                        ctx.fillText(String(line), x, y);
                        y += lineHeight;
                    }
                }

                ctx.restore();
            }
        };




        const mineTotal = (this.dataMine ?? []).reduce((a, b) => a + (Number(b) || 0), 0);
        this.chartRadar = new Chart('radarChart', {
            type: 'radar',
            data: {
                labels: wrappedLabels,
                datasets: [
                    {
                        data: this.dataMine,
                        backgroundColor: 'rgba(79, 209, 184, 0.8)',
                        borderColor: 'transparent',
                        pointRadius: 0,
                        fill: true,
                        order: 1
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    r: {
                        angleLines: { color: '#E2E6F2', lineWidth: 1 },
                        grid: { color: '#E2E6F2', lineWidth: 1 },
                        backgroundColor: '#F9FAFB',
                        pointLabels: {
                            display: true,                 
                            color: 'rgba(0,0,0,0)',        
                            font: { size: 1 },          
                            padding: 50
                        },
                        ticks: {
                            stepSize: this.maxValue / 2,
                            display: false
                        },
                        suggestedMin: 0,
                        suggestedMax: this.maxValue,
                    }
                },
                plugins: {
                    legend: {
                        display: false,
                        position: 'bottom',
                        labels: {
                            // generateLabels: function (chart) {
                            //     const labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                            //     return [labels[1], labels[0]];
                            // },
                            usePointStyle: true,
                            boxWidth: 7,
                            boxHeight: 7,
                            color: '#707988',
                            font: { size: 14 },
                            padding: 14
                        }
                    },
                    datalabels: {
                        display: false
                    }
                    // datalabels: {
                    //     color: '#1A2C76',
                    //     font: {
                    //         size: 13,
                    //         weight: 'bold'
                    //     },
                    //     formatter: (value) => value,
                    //     anchor: 'center',
                    //     align: 'end',
                    //     offset: 1,
                    //     clip: false,
                    // }
                }
            },
            plugins: [ChartDataLabels, CenterPointLabelsPlugin]
        } as ChartConfiguration);
    }
}

export default PortalAnalysisWidgetExpertiseComponent;